import React, { Component } from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import _ from "lodash";
import util from "../util/util";
import Pagination from "../pagination/pagination";
import UserListTable from "./user-list-table";

const jQuery = window.jQuery;

// use the same logic to set state (on load, on prop change);
const returnInitialState = (props = {}) => ({
  page: Number(_.get(props, `params.page`, 1)), // page of users results;
  users: [] // users to display (will be populated by an Ajax call);
});

export default class UserList extends Component {
  constructor(props) {
    super(props);

    this.state = returnInitialState(props);
  }

  componentDidMount() {
    this.mounted = true;

    this.getUsers();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentWillReceiveProps(nextProps) {
    this.setState(returnInitialState(nextProps), this.getUsers);
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-xs-6">
            <h4 className="page__title">Users</h4>
          </div>
          <div className="col-xs-6">
            <p className="page__actions">
              <Link
                to={util.returnUserFormUrl()}
                className="btn btn-primary disabled"
              >
                Manage Users
              </Link>
            </p>
          </div>
        </div>

        <hr />

        <UserListTable
          currentPage={this.state.page}
          onClickDeleteUser={user => this.deleteUser(user)}
          users={this.state.users}
        />

        <Pagination
          currentPage={this.state.page}
          pageCount={this.state.pageCount}
          path="users"
        />
      </div>
    );
  }

  // delete the user associated with this station;
  deleteUser(user) {
    const title = `Delete User from this Station`;
    const body = `<p>Are you sure you want to delete the <strong>${
      user.group ? user.group.name : `User`
    }: ${user.user.name}</strong>?</p>`;
    const buttonTextDefault = `Delete the User`;
    const buttonTextLoading = `Deleting the User`;
    const iconClass = `fa-trash-o`;
    const $modal = util.renderModal(
      title,
      body,
      buttonTextDefault,
      buttonTextLoading,
      iconClass
    );
    const $confirmButton = $modal.find(`.btn-danger`);

    // remove the user on confirmation of the modal;
    $confirmButton.one(`click`, () => {
      $confirmButton.button(`loading`);

      util
        .deleteUserFromStation(user.id)
        .fail(() => {
          setTimeout(() => {
            // reset the button on fail so it can be clicked again;
            $confirmButton.button(`reset`);
          }, util.delayForm);
        })
        .then(() => {
          // then load the users again (to update state);
          this.getUsers(() => {
            $modal.modal(`hide`);
          });
        });
    });

    // attach the modal to the DOM, and then show it;
    jQuery(`body`).append($modal);
    $modal.modal(`show`);
  }

  // get the users for this station;
  getUsers(callback = null) {
    util
      .getStationUsers({
        page: this.state.page
      })
      .then(data => {
        setTimeout(() => {
          this.mounted &&
            this.setState(
              {
                pageCount: Math.ceil(data.count / util.userResultsPerPage),
                users: data.results.length ? data.results : false
              },
              () => {
                // if a callback exists (hide modal), fire it;
                if (callback) {
                  callback();
                }
              }
            );
        }, util.delayList);
      });
  }
}

UserList.propTypes = {
  params: PropTypes.object
};
